export default __webpack_public_path__ + "static/media/icon-delivery.bb55ba55.png";